<div class="card card-widget widget-user">
  <!-- Add the bg color to the header using any of the bg-* classes -->
  <div class="widget-user-header bg-info-active">
    <div class="edit-container">
      <div class="dropdown">
        <button class="btn" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
          aria-expanded="false">
          <i class="fa fa-ellipsis-v"></i>
        </button>

        <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
          <a class="dropdown-item" style="cursor: pointer;" (click)="navigateToCustomer(customer)" translate>settings.profile</a>
          <a class="dropdown-item" style="cursor: pointer;" (click)="showDialogEditCustomer(customer)" translate>global.edit</a>
          <a *ngIf="currentUser.role.name === 'root'" class="dropdown-item" style="cursor: pointer;" (click)="showCustomerSettings(customer)" translate>Customer Settings</a>
          <a *ngIf="currentUser.role.name === 'root'" class="dropdown-item" style="cursor: pointer;" (click)="onChangeCustomer()" translate>Transfer Customer</a>
          <div class="dropdown-divider"></div>
          <a class="dropdown-item" style="cursor: pointer;" (click)="navigateToCustomerInvoices(customer)" translate>Invoices</a>
          <a class="dropdown-item" style="cursor: pointer;" (click)="openDialogClientsInvoices(customer)" translate>Clients Invoices</a>
          <a *ngIf="showChangePassword" class="dropdown-item" style="cursor: pointer;" (click)="showDialogChangePassword(customer)" translate>Change Password</a>
        </div>
      </div>
    </div>
    <h3 style="font-size: 1.3rem;" class="widget-user-username">{{customer.name}}</h3>
    <h6 class="widget-user-desc">{{customer.email}}</h6>
  </div>
  <div class="widget-user-image">
    <img class="img-circle elevation-2" src="/assets/img/catcher.png" alt="User Avatar">
  </div>
  <div class="card-footer">
    <div class="d-flex justify-content-between align-items-center w-100">
      <div class="d-flex flex-column">
        <div class="customer-text"><span translate>customer.credits</span>: {{customer.credits ? customer.credits : 0}}</div>
        <div class="customer-text"><span translate>customer.premiumCredits</span>: {{customer.premiumCredits ? customer.premiumCredits : 0}}</div>
      </div>
      <button type="button" class="custom-button" style="min-width: 60px;"
        (click)="showDialogAddCustomerCredit(customer)" translate>global.add</button>
    </div>
  </div>
</div>

<!-- Modal Form EDIT Customer -->
<ng-template #dialogEditCustomer let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title" translate>{{currentUser.role.name === 'root' && !customerId ? 'customer.editCustomer': 'customer.editSubcustomer'}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form #editCustomerForm="ngForm" (ngSubmit)="sendEditCustomer(editCustomerForm)" class="form-vehicle">
      <!-- Full name -->
      <div class="row">
        <div class="input-group mb-3 col-lg-12 col-md-12 col-sm-12">
          <div class="input-group-prepend">
            <span class="input-group-text" id="basic-addon3" translate>customer.fullName</span>
          </div>
          <input type="text" autocomplete="off" class="form-control" id="name" name="name"
            [ngModel]="editCustomer.name">
        </div>
      
      <div class="input-group mb-3 col-lg-12 col-md-12 col-sm-12">
        <div class="input-group-prepend">
          <span class="input-group-text" id="basic-addon3" translate>Info email</span>
        </div>
        <input type="email" #infoEmail="ngModel" autocomplete="off" [ngModel]="editCustomer.infoEmail" class="form-control" name="infoEmail">
      </div>
      </div>
      <!-- childs -->
      <div *ngIf="currentUser.role.name === 'root'" class="d-flex justify-content-between mb-4 align-items-center">
        <div class="w-100">
          <p>{{currentUser.role.name === 'root' && !customerId ? 'Allow customer to create subcustomers?': 'Allow subcustomer to create subcustomers?'}}</p>
        </div>
        <div style="position: relative;" class="row">
          <div class="choose-window">
            <p>Off</p>
            <label class="switch">
              <input type="checkbox" name="allowChilds" [ngModel]="editCustomer.allowChilds">
              <span class="slider round"></span>
            </label>
            <p>Allow</p>
          </div>
        </div>
      </div>

      <div *ngIf="currentUser.role.name === 'root'" class="d-flex justify-content-between mb-4 align-items-center">
        <div class="w-100">
          <p>{{currentUser.role.name === 'root' && !customerId ? 'Allow customer to go in minus?': 'Allow subcustomer to go in minus?'}}</p>
        </div>
        <div style="position: relative;" class="row">
          <div class="choose-window">
            <p>Off</p>
            <label class="switch">
              <input type="checkbox" name="allowNegativeCredits" [ngModel]="editCustomer.allowNegativeCredits">
              <span class="slider round"></span>
            </label>
            <p>Allow</p>
          </div>
        </div>
      </div>

      <div *ngIf="currentUser.role.name === 'root'" class="d-flex justify-content-between mb-4 align-items-center">
        <div class="w-100">
          <p>Allow option to send notification?</p>
        </div>
        <div style="position: relative;" class="row">
          <div class="choose-window">
            <p>Off</p>
            <label class="switch">
              <input type="checkbox" name="isNotify" [ngModel]="editCustomer.isNotify">
              <span class="slider round"></span>
            </label>
            <p>Allow</p>
          </div>
        </div>
      </div>
      <!-- LOGO -->
      <div *ngIf="currentUser.role.name === 'root' && !customerId" class="form-group">
        <div class="d-flex justify-content-between mb-4">
          <div>
            Logo
          </div>
          <div style="width: 100px;">
            <input type="file" id="logo" style="display: none;" (change)="getFile($event)">
            <div *ngIf="!editCustomer.logo">
              <div class="upload_container" (click)="chooseLogo()">
                Upload Logo
              </div>
            </div>
            <div *ngIf="previewLogo">
              <img style="cursor: pointer;" class="img-fluid" [src]="previewLogo" (click)="chooseLogo()" alt="logo">
            </div>
            <img style="cursor: pointer;" *ngIf="editCustomer.logo" class="img-fluid"
              [src]="editCustomer.logo.thumbnailPath" (click)="chooseLogo()" alt="logo">
          </div>
        </div>
      </div>

      <div class="row d-flex justify-content-center">
        <div class="col-lg-6 col-md-12 ">
          <div class="form-group ">
            <button type="submit" class="form-control btn btn-block btn-success" translate>{{currentUser.role.name === 'root' && !customerId ? 'customer.editCustomer': 'customer.editSubcustomer'}}</button>
            <button class="form-control btn btn-block btn-danger" (click)="customerToDelete(dialogDeleteCustomer)" translate>{{currentUser.role.name === 'root' && !customerId ? 'customer.deleteCustomer': 'customer.deleteSubcustomer'}}</button>
          </div>
        </div>
      </div>
    </form>
    <!-- <div class="delete-customer" (click)="toggleAddAdmin = true">New Admin</div> -->
  </div>
</ng-template>

<!-- Modal delete customer -->
<ng-template #dialogDeleteCustomer let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h3 class="modal-title" style="font-size: 16px">Are you sure you want to delete <span
        style="font-weight: bold;">{{editCustomer.name}}</span> ?</h3>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <button type="button" class="btn btn-outline-dark btn-yes" (click)="deleteCustomer()"
      translate>global.yes</button>
    <button type="button" class="btn btn-outline-dark btn-no" (click)="c('No click')"
      translate>global.no</button>
  </div>
</ng-template>

<!-- Modal Form ADD Customer Credit -->
<ng-template #dialogAddCustomerCredit let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title" translate>customer.addCustomerCredit</h4>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form #customerCreditForm="ngForm" (ngSubmit)="sendCustomerCredit(customerCreditForm)" class="form-vehicle">
      <!-- Credit Type -->
      <div class="row">
        <div class="input-group mb-3 col-lg-12 col-md-12 col-sm-12">
          <div class="input-group-prepend">
            <span class="input-group-text" translate>customer.creditType</span>
          </div>
          <select class="form-control" name="creditType" ngModel="credits">
            <option value="credits">Credits</option>
            <option value="premiumCredits" [disabled]="!customerToAddCredit?.usePremium">Premium Credits</option>
          </select>
        </div>
      </div>
      <!-- Credit -->
      <div class="row">
        <div class="input-group mb-3 col-lg-12 col-md-12 col-sm-12">
          <div class="input-group-prepend">
            <span class="input-group-text" id="basic-addon3" translate>customer.credit</span>
          </div>
          <input type="number" class="form-control" id="credit" name="credit" ngModel>
          <button type="submit" class="form-control btn btn-block btn-success" translate>global.add</button>
        </div>
      </div>
    </form>
  </div>
</ng-template>

<app-clients-invoice #dialogClientsInvoices [customer]="editCustomer"></app-clients-invoice>

<app-modal (close)="handleCloseSettings()" *ngIf="toggleCustomerSettings">
  <div *ngIf="currentUser && customerSettings" 
    style="letter-spacing: initial;
      color: #000;
      text-align: left;
      line-height: initial;
      padding: 8px;"
    class="form-container w-100"
  >
    <div class="d-flex justify-content-between mb-4 align-items-center">
      <div class="w-100">
        <p translate>settings.notifyInfo</p>
      </div>
      <div style="position: relative;" class="row">
        <div class="choose-window">
          <p translate>global.off</p>
          <label class="switch">
            <input type="checkbox" (change)="patchCreditsNotification($event)" name="creditsNotificationEnabled"
              [ngModel]="customerSettings.creditsNotificationEnabled">
            <span class="slider round"></span>
          </label>
          <p translate>global.on</p>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-between mb-4">
      <p translate>settings.creditLimit</p>
      <div class="d-flex">
        <input type="number" class="form-control" name="creditsNotificationThreshold"
          [(ngModel)]="customerSettings.creditsNotificationThreshold">
        <button class="custom-button" style="margin-left: 10px; padding: 4px 18px;" (click)="updateTreshold()"
          translate>global.save</button>
      </div>
    </div>
    <div class="d-flex justify-content-between mb-4">
      <p translate>global.infoEmail</p>
      <div class="d-flex">
        <input type="email" class="form-control" name="infoEmail"
          [(ngModel)]="infoEmail" style="width: 200px;">
        <button class="custom-button" style="margin-left: 10px; padding: 4px 18px;" (click)="updateInfoEmail()"
          translate>global.save</button>
      </div>
    </div>
  </div>
</app-modal>

<app-modal (close)="onCloseCustomer()" *ngIf="toggleChangeCustomer">
  <div class="modal_container black-text">
    <p class="text-header-modal">Transfer Customer</p>
    <div #searchContainer [ngClass]="{'active' : showCustomers}" class="div select-bg search-container w-100"
      style="display: block;">
      <input type="text" readonly class="search" style="height: 44px; display: block; width: 100%; padding-left: 12px;"
        (click)="openCustomers()" name="selectedPreset"
        [placeholder]="selectedCustomer ? selectedCustomer.name : 'Select Customer...'">

      <div class="form-group">
        <div class="prikaz" *ngIf="showCustomers">
          <div class="backdrop" (click)="openCustomers()"></div>
          <div style="z-index: 100; overflow-y: auto;">
            <div class="divider"></div>
            <input type="text" class="search-marke" (input)="applyCustomerFilter()"
              [attr.placeholder]="'user.search' | translate" name="searchCustomersParam" name="searchCustomersParam"
              [(ngModel)]="searchCustomersParam">
            <ul style="margin-bottom: 12px;">
              <li *ngFor="let customer of customersSearch"
                (click)="showCustomers=!showCustomers; selectCustomer(customer)">
                {{ customer.name }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="customer.parentId" style="margin-top: 1rem; display: flex; align-items: center; gap: 1rem;">
      <input name="parent" id="parent" type="checkbox" (ngModel)="transferToParent" (change)="handleChangeToParent()">
      <label for="parent">Make parent customer</label>
    </div>

    <div style="min-height: 100px;"></div>
    <p class="p-2" style="font-size: .93rem;" *ngIf="selectedCustomer">Move to {{selectedCustomer.name}}</p>

    <button style="width: 150px;" (click)="transferCustomer()" class="custom-button mt-3">SAVE</button>
  </div>
</app-modal>